import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MeetingService } from "../components/MeetingService"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { UserResourceBooking } from "../components/ServiceCenterResourceBookings"

export function ServiceCenterMeetingService() {
    const { l10n } = useAppLocalization()

    const tabs = [
        {
            label: l10n.getString("user-nav-item-upcoming-orders-resource-bookings"),
            component: <UserResourceBooking />,
        },
        {
            label: l10n.getString("user-nav-item-upcoming-orders-meeting-service"),
            component: <MeetingService />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="service-center-reports-upcoming-meetings-title" attrs={{ title: true }}>
                <PageHeader page={Page.SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE} title="Upcoming meetings" />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
